import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = ({ onEnrollClick }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-logo">
          <img 
            src="/logo.png" 
            alt="Tesla's Academy" 
            className="navbar-logo-img"
          />
          <span className="navbar-brand">Tesla's Academy</span>
        </div>
        
        <ul className={`navbar-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <li>
            <button className="navbar-link" onClick={() => scrollToSection('home')}>
              Home
            </button>
          </li>
          <li>
            <button className="navbar-link" onClick={() => scrollToSection('about')}>
              About
            </button>
          </li>
          <li>
            <button className="navbar-link" onClick={() => scrollToSection('gallery')}>
              Gallery
            </button>
          </li>
          <li>
            <button className="navbar-link" onClick={() => scrollToSection('programs')}>
              Programs
            </button>
          </li>
          <li>
            <button className="navbar-link" onClick={() => scrollToSection('achievements')}>
              Achievements
            </button>
          </li>
          <li>
            <button className="navbar-link" onClick={() => scrollToSection('testimonials')}>
              Testimonials
            </button>
          </li>
          <li>
            <button className="navbar-link" onClick={() => scrollToSection('branches')}>
              Branches
            </button>
          </li>
          <li>
            <button className="navbar-link" onClick={() => scrollToSection('career-compass')}>
              Career Compass
            </button>
          </li>
          <li>
            <button className="navbar-link navbar-cta" onClick={onEnrollClick}>
              Enroll Now
            </button>
          </li>
        </ul>
        
        <button 
          className="mobile-menu-btn" 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          ☰
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
